import { FC } from 'react'

import { usePriceFilter } from '../hooks/usePriceFilter'
import { formatPrice } from '../lib/format-price'

import cls from './price-filter.module.scss'

interface PriceFilterProps {
	minValue: string
	maxValue: string
	checkedFrom?: string
	checkedTo?: string
	isDisabled?: boolean
	title?: string
	onSubmit: (from: string, to: string) => void
}

export const PriceFilter: FC<PriceFilterProps> = ({
	minValue,
	maxValue,
	checkedFrom,
	checkedTo,
	isDisabled,
	title = 'Цена',
	onSubmit
}) => {
	const formatInputValue = (value: string): string => {
		const num = Number(value)
		return value && !Number.isNaN(num) ? formatPrice(num) : ''
	}

	const { priceFrom, priceTo, handleFromChange, handleToChange, handleBlur, handleKeyDown } = usePriceFilter({
		minValue,
		maxValue,
		checkedFrom,
		checkedTo,
		onSubmit
	})

	return (
		<div className={cls.root}>
			<p className={cls.title}>{title}</p>
			<div className={cls.inputs}>
				<div className={cls.inputWrapper}>
					<span className={cls.label}>от</span>
					<input
						type="text"
						inputMode="numeric"
						className={cls.input}
						value={formatInputValue(priceFrom)}
						onChange={handleFromChange}
						onBlur={handleBlur}
						onKeyDown={handleKeyDown}
						disabled={isDisabled}
					/>
				</div>
				<span className={cls.separator}>–</span>
				<div className={cls.inputWrapper}>
					<span className={cls.label}>до</span>
					<input
						type="text"
						inputMode="numeric"
						className={cls.input}
						value={formatInputValue(priceTo)}
						onChange={handleToChange}
						onBlur={handleBlur}
						onKeyDown={handleKeyDown}
						disabled={isDisabled}
					/>
				</div>
			</div>
		</div>
	)
}
